"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsHeaderActionsShow = void 0;
var react_1 = require("react");
var globalSlice_1 = require("../features/global/globalSlice");
var react_redux_1 = require("react-redux");
var useIsHeaderActionsShow = function (route) {
    var dispatch = react_redux_1.useDispatch();
    react_1.useEffect(function () {
        dispatch(globalSlice_1.setIsShowHeaderActions(route.isHeaderActionsShow));
        return function () {
            dispatch(globalSlice_1.setIsShowHeaderActions(true));
        };
    }, []);
};
exports.useIsHeaderActionsShow = useIsHeaderActionsShow;
